import React from "react";
import Header from "../../components/header/Header.component";
import Footer from "../../components/footer/Footer.component";

import "../top-airlines/top-airlines.style.css";
import BannerSearchForm from "../../components/flight-search-form/BannerSearchForm.component";
import FlightSearchForm from "../../components/flight-search-form/FlightSearchForm.component";

export const LasVegas = () => {
  return (
    <>
      <div className="home-banner">
        <div className="cm-page-center">
          <div className="search-banner">
            <h1>Let Airefare bring your dream vacation to new heights.</h1>
            <FlightSearchForm />
          </div>
        </div>
      </div>
      <div className="cm-section cm-page-center">
        {/* <BannerSearchForm depVal={data} urlVal={dataToSend} /> */}
        <div className="ryan-air">
          <div className="ryanair-title">
            <h1>Las Vegas</h1>
          </div>
          <div className="ryanair-content">
            <p>
              Get ready for the journey by packing your luggage and making
              reservations for flights to Las Vegas. You may easily tailor your
              trip to your preferences, whether you want an exciting escape or a
              relaxing vacation. More than 2.9 million visitors traveled to this
              incredible, vibrant city in the United States in 2019. Visit the
              must-see casinos while you're there and take in the views of the
              most beautiful places. It's hardly surprising that travelers and
              adventure seekers are lured to this appealing location.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};
